import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    authStatus: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.BRAND_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.BRAND_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                authStatus: action?.payload?.authStatus,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.BRAND_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                authStatus: action?.payload?.authStatus,
                message: action?.payload?.message,
            }
        case actionTypes.BRAND_LIST_RESET:
            return {
                ...state,
                status: '',
                authStatus: '',
                message: ''
            }
        case actionTypes.BRAND_LIST_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
